import React from "react";
import { Card, Header } from "semantic-ui-react";
import { isMobile } from "react-device-detect";
import "../../node_modules/react-vis/dist/style.css";
import "../css/home.css";
import CompareResults from "../main/CompareResults";
import CashflowGrowthCheck from "./CashflowGrowthCheck";
import CompanyProfile from "./CompanyProfile.js";
import DebtCheck from "./DebtCheck";
import EPSGrowthCheck from "./EPSGrowthCheck";
import FairPriceCheck from "./FairPriceCheck";
import MoatCheck from "./MoatCheck";
import NetIncomeGrowthCheck from "./NetIncomeGrowthCheck";
import RoeCheck from "./RoeCheck";
import SalesGrowthCheck from "./SalesGrowthCheck";

export default function CompleteReport(props) {
  const getHeaderCard = (name) => {
    return (
      <div className="complete-report-section-wrap">
        <Card fluid raised className="complete-report-section-header">
          <Card.Content>
            <Card.Description>
              <Header as="h2" textAlign="center" className="complete-report-section-title">
                {name}
              </Header>
            </Card.Description>
          </Card.Content>
        </Card>
      </div>
    );
  };

  return (
    <div
      className="complete-report-page"
      style={{
        maxWidth: 1280,
        margin: "0 auto",
        padding: isMobile ? "2rem 0.5rem" : "2rem 1rem",
        boxSizing: "border-box",
      }}
    >
      {getHeaderCard("Company Profile")}
      <CompanyProfile stockValues={props.stockValues} />

      <div className="complete-report-section-spacer">{getHeaderCard("Revenue Growth")}</div>

      <SalesGrowthCheck stockValues={props.stockValues} />

      <div className="complete-report-section-spacer">{getHeaderCard("Net Income Growth")}</div>
      <NetIncomeGrowthCheck stockValues={props.stockValues} />

      <div className="complete-report-section-spacer">{getHeaderCard("Cashflow Growth")}</div>
      <CashflowGrowthCheck stockValues={props.stockValues} />

      <div className="complete-report-section-spacer">{getHeaderCard("EPS Growth")}</div>
      <EPSGrowthCheck stockValues={props.stockValues} />

      <div className="complete-report-section-spacer">{getHeaderCard("Moat Check")}</div>
      <MoatCheck stockValues={props.stockValues} />

      <div className="complete-report-section-spacer">{getHeaderCard("ROE Check")}</div>
      <RoeCheck stockValues={props.stockValues} />

      <div className="complete-report-section-spacer">{getHeaderCard("Debt Check")}</div>
      <DebtCheck stockValues={props.stockValues} />

      <div className="complete-report-section-spacer">{getHeaderCard("Fair Price Check")}</div>
      <FairPriceCheck stockValues={props.stockValues} />

      <div className="complete-report-section-spacer">{getHeaderCard("Compare to Peers")}</div>
      <CompareResults stckLst={props.compareResults} />
    </div>
  );
}
